



























































































import { Mutation, Action } from 'vuex-class'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapState, mapMutations } from 'vuex'
import gameOneIcon from '@/assets/game1.png'
import gameTwoIcon from '@/assets/game2.png'
import gameThreeIcon from '@/assets/game3.png'
import QuickDeposits from '@/components/gambling/QuickDeposit.vue'
import HomePageOne from '@/components/gambling/Home/HomePageOne.vue'
import HomePageTwo from '@/components/gambling/Home/HomePageTwo'
import HomePageThree from '@/components/gambling/Home/HomePageThree.vue'
import HomePageFour from '@/components/gambling/Home/HomePageFour.vue'
import { setCountryUserId } from '@/utils/gamblingHelpers'

declare global {
  interface Window {
      createdFromGamblingHome: any
  }
}

@Component({
  components: {
    QuickDeposits,
    HomePageOne,
    HomePageTwo,
    HomePageThree,
    HomePageFour
  },
  computed: {
    ...mapState({
      isAuthenticated: ({ gamblingContext }: any): boolean => gamblingContext.isAuthenticated,
      fullName: ({ gamblingContext }: any): null | string => gamblingContext.credentials.username,
      currencyCode: ({ gamblingContext }: any) => gamblingContext.currencyCode,
      autoProcessProvider: ({ cashierContext }: any): string => cashierContext.autoProcessProvider,
      choosedTheme: ({ gamblingContext }: any): string => gamblingContext.choosedTheme,
      pageLayout: ({ gamblingContext }: any) => gamblingContext.pageLayout,
      countries: ({ cashierContext }: any) => cashierContext.countries,
      userId: ({ cashierContext }: any) => cashierContext.config.userId
    })
  }
})

export default class GamblingHome extends Vue {
  @Action('reloadCashier') reloadCashier: any
  @Mutation('setLogInModal') setLogInModalCommit: any
  @Mutation('setAccountType') setAccountType: any
  public $routeChange!: any
  public $cashierConfigs!: any
  private autoProcessProvider!: string
  private isAuthenticated!: boolean
  private quickDeposit: boolean = false
  private campaignSeconds: number = 30
  private cards: object[] = [
    { src: gameOneIcon },
    { src: gameTwoIcon },
    { src: gameThreeIcon }
  ]
  private choosedCountry: string = 'UK'
  private countryDialog: boolean = false
  private themeModal: boolean = false
  private userId!: string | number
  private countries!: string[]
  private pageLayout!: string

  @Watch('choosedCountry')
  onChoosedCountry (val: string) {
    console.log(val)
    this.setCountry(val)
  }

  @Watch('isAuthenticated')
  onIsAuthenticated (val: boolean) {
    if (val === true) {
      this.campaignSeconds = 30
    }
  }

  get excludePageLayouts () {
    const exclude = [
      'layout2',
      'layout4'
    ]
    return !exclude.includes(this.pageLayout)
  }

  get countriesSorted () {
    return this.countries.map((country: any) => country.country).sort()
  }

  get iconBg () {
    const theme = document.querySelector('#gambling-theme-vars')
    const iconBg = theme && theme.innerHTML.includes('--icon-bg')
    if (iconBg) {
      return 'icon-bg'
    } else {
      return 'highlight-text-color'
    }
  }

  get providerImg () {
    return `https://static.paymentiq.io/${this.autoProcessProvider}.png`
  }

  get getCountry () {
    const { country }: any = this.countries.find((val: any) => val.userId === this.userId)
    return country
  }

  private setCountry (countryPar: string) {
    const { userId }: any = this.countries.find((country: any) => country.country === countryPar) || {}
    userId && setCountryUserId(userId)
    if (!window.createdFromGamblingHome) {
      this.countryDialog = false
    }
  }

  private openCountryDialog () {
    window.createdFromGamblingHome = true
    setTimeout(() => {
      window.createdFromGamblingHome = false
    }, 500)
    const country: any = this.getCountry
    const choosedCountry: string = country
    this.choosedCountry = choosedCountry
    this.countryDialog = true
  }

  private setLogInModal () {
    this.setLogInModalCommit(true)
  }

  private closeDialog (): void {
    this.quickDeposit = false
  }

  private depositCampaign (): void {
    this.setAccountType('banking')
    this.campaignSeconds = 0
    this.quickDeposit = true
  }

  private makeDeposit () {
    this.reloadCashier({ method: 'deposit' })
    this.setAccountType('banking')
    this.$routeChange('/gambling/account')
  }

  private created (): void {
    this.choosedCountry = this.getCountry
    let campaignInterval: any = null
    campaignInterval = setInterval(() => {
      this.campaignSeconds = (this.campaignSeconds - 1)
    }, 1000)
    setTimeout(() => {
      clearInterval(campaignInterval)
    }, 31000)
  }
}
